import { w as writable } from "./index2.js";
import { I as InfoCircleSolid } from "./InfoCircleSolid.js";
const globalToast = writable({
  icon: InfoCircleSolid,
  open: false,
  content: "Toast",
  color: "green",
  timed(content, duration = 3e3, icon = InfoCircleSolid) {
    globalToast.update((toast) => {
      toast.content = content;
      toast.icon = icon;
      toast.open = true;
      return toast;
    });
    setTimeout(() => {
      globalToast.update((toast) => {
        toast.open = false;
        return toast;
      });
    }, duration);
  }
});
export {
  globalToast as g
};
//# sourceMappingURL=toast2.js.map
